<div class="vc-root">

  <!-- camera error state -->
  <div class="vc-error" *ngIf="cameraError">
    <div class="vc-error-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M15 10l4.553-2.069A1 1 0 0121 8.87v6.259a1 1 0 01-1.447.894L15 14" />
        <rect x="3" y="6" width="12" height="12" rx="2" />
        <line x1="3" y1="3" x2="21" y2="21" />
      </svg>
    </div>
    <p class="vc-error-text">{{ cameraError }}</p>
    <button class="try-btn" (click)="startCamera()">{{'custom_camera.video_try_again_btn' | translate}}</button>
  </div>

  <!-- main capture view -->
  <div class="vc-capture" *ngIf="!hasPreview && !cameraError">

    <!-- viewfinder -->
    <div class="vc-viewfinder">
      <video #videoPreview class="vc-video" autoplay playsinline muted>
      </video>
      <!-- recording overlay — progress ring + timer -->
      <div class="vc-recording-hud" *ngIf="isRecording">
        <div class="vc-ring-container">
          <svg class="vc-ring" viewBox="0 0 120 120">
            <circle class="vc-ring-track" cx="60" cy="60" r="54" />
            <circle class="vc-ring-fill" cx="60" cy="60" r="54"
              [style.stroke-dashoffset]="339.3 - (339.3 * progressPercent / 100)" />
          </svg>
          <div class="vc-timer-display">
            <span class="vc-timer-elapsed">{{ formattedElapsed }}</span>
            <!-- <span class="vc-timer-max">/ 0:30</span> -->
          </div>
        </div>
        <div class="vc-countdown-badge" [class.vc-countdown-urgent]="countdown <= 5">
          {{ countdown }}s left
        </div>
      </div>

      <!-- processing spinner over viewfinder -->
      <div class="vc-processing-overlay" *ngIf="isProcessing">
        <div class="vc-spinner-wrap">
          <ion-spinner name="crescent" color="light"></ion-spinner>
          <span>{{'custom_camera.video_processing_video' | translate}}</span>
        </div>
      </div>

      <!-- camera not ready yet -->
      <div class="vc-loading-overlay" *ngIf="!isCameraReady && !isProcessing">
        <ion-spinner name="crescent" color="light"></ion-spinner>
      </div>

      <!-- recording indicator dot -->
      <div class="vc-rec-dot" *ngIf="isRecording">
        <span class="vc-rec-pulse"></span>
        {{'custom_camera.video_rec_text' | translate}}
      </div>
    </div>

    <!-- controls -->
    <div class="vc-controls">

      <!-- top row: cancel + flip -->
      <!-- <div class="vc-controls-top">
        <button class="vc-icon-btn" (click)="cancel()" [disabled]="isRecording || isProcessing" aria-label="Cancel">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <button class="vc-icon-btn" (click)="flipCamera()" [disabled]="isRecording || isProcessing || !isCameraReady"
          aria-label="Flip camera">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 4v6h6" />
            <path d="M23 20v-6h-6" />
            <path d="M20.49 9A9 9 0 005.64 5.64L1 10" />
            <path d="M3.51 15a9 9 0 0014.85 3.36L23 14" />
          </svg>
        </button>
      </div> -->

      <!-- bottom row: record button -->
      <div class="vc-controls-bottom">

        <!-- left: cancel -->
        <button class="vc-icon-btn" (click)="cancel()" [disabled]="isRecording || isProcessing" aria-label="Cancel">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <!-- centre: record button + hint stacked -->
        <div class="vc-record-wrap">
          <button class="vc-record-btn" [class.vc-record-btn--recording]="isRecording"
            (click)="isRecording ? stopRecording() : startRecording()" [disabled]="!isCameraReady || isProcessing"
            aria-label="{{ isRecording ? 'Stop recording' : 'Start recording' }}">
            <span class="vc-record-inner"></span>
          </button>
          <span class="vc-record-hint">
            {{ isRecording ? 'Tap to stop' : 'Tap to record' }}
          </span>
        </div>

        <!-- right: flip -->
        <button class="vc-icon-btn" (click)="flipCamera()" [disabled]="isRecording || isProcessing || !isCameraReady"
          aria-label="Flip camera">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round">
            <path d="M1 4v6h6" />
            <path d="M23 20v-6h-6" />
            <path d="M20.49 9A9 9 0 005.64 5.64L1 10" />
            <path d="M3.51 15a9 9 0 0014.85 3.36L23 14" />
          </svg>
        </button>

      </div>
    </div>
  </div>

  <!-- preview view -->
  <div class="vc-preview" *ngIf="hasPreview && !cameraError">

    <!-- <div class="vc-preview-header">
      <span class="vc-preview-badge">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="10" />
        </svg>
        {{ previewDuration }}s
      </span>
    </div> -->

    <div class="vc-preview-player">
      <video #videoPlayback class="vc-video vc-video--preview" [src]="previewUrl" controls playsinline
        preload="metadata">
      </video>
    </div>

    <!-- processing overlay for use video -->
    <div class="vc-processing-overlay vc-processing-overlay--preview" *ngIf="isProcessing">
      <div class="vc-spinner-wrap">
        <ion-spinner name="crescent" color="light"></ion-spinner>
        <span>{{'custom_camera.video_saving_photo' | translate}}</span>
      </div>
    </div>

    <div class="vc-preview-actions">
      <button class="vc-btn vc-btn--ghost" (click)="retake()" [disabled]="isProcessing">
        {{'custom_camera.video_retake_btn' | translate}}
      </button>
      <button class="vc-btn vc-btn--primary" (click)="useVideo()" [disabled]="isProcessing">
        {{'custom_camera.video_use_photo_btn' | translate}}
      </button>
    </div>
  </div>

</div>